import script from "./common-table.vue?vue&type=script&setup=true&lang=js"
export * from "./common-table.vue?vue&type=script&setup=true&lang=js"

import "./common-table.vue?vue&type=style&index=0&id=4b27e9f6&lang=scss"

const __exports__ = script;

export default __exports__